// componente para la redireccion de servicio

import { useEffect, useState } from "react";


// import the react translation
import { useTranslation } from "react-i18next";



// react router dom importation
import { useNavigate } from "react-router-dom";








export const MsgRedirectComp = ({ idCall }) => {

  const [counter, setCounter] = useState(10); // estado para el contador

  // GET the useNavigate
  const navigate = useNavigate();


  // GET the react translation
  const [t] = useTranslation("global");



  // useEffect para el counter
  useEffect(() => {

    const timer = setInterval(() => {
      if (counter > 0) {
        setCounter(counter - 1);
      } else {
        clearInterval(timer);
        // redireccionar a las llamadas abiertas
        navigate("/tracking-case");
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };

  }, [counter]);



  return (
    <div className="background-modal">
      <div className="container-modal">
        <h5 className="txt-center">
          {t("NewCallComp.ticket_aperturado")} <strong className="fake-link-2">{idCall}</strong> {t("NewCallComp.en")} {counter} {t("NewCallComp.modal_cerrado")}
        </h5>

        <div className="m-y-small">
          <button type="button" className="btn-success" onClick={() => navigate("/tracking-case")}>OK!</button>
        </div>
      </div>
    </div>
  );
};